import React from 'react';

export function getTheme(dark) {
  return {
    bgPrimary:      dark ? '#393e40' : '#ffffff',
    bg100:          dark ? '#494f52' : '#ffffff',
    bg200:          dark ? '#596063' : '#e6e6e6',
    bg300:          dark ? '#687175' : '#d9d9d9',
    text100:        dark ? '#ffffff'  : '#262626',
    text200:        dark ? '#d9d9d9'  : '#404040',
    text400:        dark ? '#a6a6a6'  : '#737373',
    cardBg:         dark ? '#494f52'  : '#ffffff',
    cardBg100:      dark ? '#393e40'  : '#f2f2f2',
    btnPrimaryBg:   dark ? '#ffffff'  : '#303f46',
    btnPrimaryText: dark ? '#404040'  : '#ffffff',
    settingsActive: dark ? '#5d7b88'  : '#495f6a',
    toggleOffBg:    dark ? '#596063'  : '#e6e6e6',
    toggleOnBg:     dark ? '#889399'  : '#495f6a',
    border:         dark ? '#596063'  : '#e6e6e6',
    inputBg:        dark ? '#494f52'  : '#ffffff',
    inputBorder:    dark ? '#687175'  : '#d9d9d9',
    btnSecondaryBg:       dark ? '#596063' : '#ffffff',
    btnSecondaryText:     dark ? '#ffffff' : '#404040',
    btnSecondaryBorder:   dark ? '#788287' : '#bfbfbf',
    btnTertiaryBg:        dark ? '#393e40' : '#f0f3f5',
    audioRingOuter:       dark ? '#494f52' : '#f2f2f2',
    btnTertiaryText:      dark ? '#ffffff' : '#404040',
    cardSelectedBorder:   dark ? 'rgba(255, 255, 255, 0.5)' : 'rgba(73, 95, 106, 0.5)',
    modalBg:              dark ? '#393e40' : '#ffffff',
    modalCloseIcon:       dark ? '#889399' : '#8c8c8c',
    moralBoxBg:           dark ? '#7a6451' : '#f9e3d0',
    toolActiveIcon:       dark ? '#b3c4cb' : '#495f6a',
    storyCardSelectedBg:  dark ? '#494f52' : 'rgba(184, 199, 207, 0.5)',
    storyCardUnselectedBg: dark ? '#393e40' : '#ffffff',
    placeholderColor: dark ? '#687175' : '#a6a6a6',
  };
}

export const ThemeContext = React.createContext(getTheme(false));
